import React from 'react';
import { useTranslation } from 'react-i18next';

import { SkyviewContext } from '../../../skyview/skyview-state';
import { ToolIcon } from '../../../skyview-new/toolbar/tool-icon';

const FocusToolIcon = () => {
  const { t } = useTranslation();
  const { skyview } = React.useContext(SkyviewContext);

  return (
    <ToolIcon
      active={false}
      callback={() => {
        skyview.focusOnGeodata();
      }}
      icon={['fal', 'expand']}
      tooltip={{
        title: t('focus.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('focus.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { FocusToolIcon };
